<h2 class="primary-brand-color mb-5">
  {{
    'admin.register.registerHeaderMessage1'
      | translate: { tenantName: this.tenantName }
  }}
  <span class="text-turquoise">{{
    'admin.register.registerHeaderMessage2' | translate
  }}</span>
</h2>

<form
  [formGroup]="registerForm"
  (submit)="registerFormAction()"
  appPreventEnter
>
  <div class="row mb-3 mb-xs-cust">
    <div class="col-12">
      <app-mat-input
        type="email"
        label="admin.global.email"
        [value]="newUser.email"
        fieldClass="full-width"
        [hint]="!social ? 'admin.register.emailInfo' : ''"
      ></app-mat-input>
    </div>
  </div>
  <div class="row mb-0-cust">
    <div
      class="col-6"
      [ngClass]="{ 'mb-3': firstName.touched && firstName.errors }"
    >
      <app-mat-input
        [control]="$any(firstName)"
        label="admin.global.firstName"
        inputId="register-first-name-field"
        autocomplete="given-name"
        fieldClass="full-width"
        errorSuffix="."
        [errors]="{
          required: 'admin.global.field.required',
          minlength: 'admin.global.field.minLength',
          maxlength: 'admin.global.field.maxLength',
          containsUrl: 'admin.global.field.containsUrl',
        }"
      ></app-mat-input>
    </div>
    <div
      class="col-6"
      [ngClass]="{ 'mb-3': lastName.touched && lastName.errors }"
    >
      <app-mat-input
        [control]="$any(lastName)"
        label="admin.user.details.lastName"
        inputId="register-last-name-field"
        autocomplete="family-name"
        fieldClass="full-width"
        errorSuffix="."
        [errors]="{
          required: 'admin.global.field.required',
          minlength: 'admin.global.field.minLength',
          maxlength: 'admin.global.field.maxLength',
          containsUrl: 'admin.global.field.containsUrl',
        }"
      ></app-mat-input>
    </div>
  </div>
  <div
    class="row"
    [ngClass]="{ 'mb-3': countryId.touched && countryId.errors }"
  >
    <div class="col-12">
      <!-- RAW Material field by design (doc §68): the auth forms are outlined
           mat-form-fields; app-select renders the admin bootstrap select and
           broke the form's look. Develop markup verbatim. -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ 'admin.global.country' | translate }}</mat-label>
        <mat-select
          formControlName="countryId"
          id="register-country-field"
          (selectionChange)="onCountryChanged($event)"
        >
          <mat-option [value]="">{{
            'admin.global.pleaseSelect' | translate
          }}</mat-option>
          <mat-option
            *ngFor="let country of countriesList"
            [value]="country.id"
            >{{ country.name }}</mat-option
          >
        </mat-select>
        <mat-error
          *ngIf="
            countryId.touched && countryId.errors && countryId.errors.required
          "
        >
          {{ 'admin.global.field.required' | translate }}.
        </mat-error>
      </mat-form-field>
    </div>
  </div>
  <div class="row mb-0-cust mb-lg-3">
    <div id="inputPhone" class="col-12 phone-field">
      <app-phone-input
        [id]="'phone'"
        [countryCode]="getCountryCode()"
        [matForm]="true"
        formControlName="phoneNumber"
        (phoneInputChange)="onPhoneChange($event)"
        [placeholder]="false"
        [minHeight]="'38'"
      >
      </app-phone-input>
      <mat-error
        *ngIf="phoneNumber.invalid && phoneNumber.touched"
        class="phone-field__error"
        >{{ 'public.payment.errors.valueNotValid' | translate }}</mat-error
      >
    </div>
  </div>
  <app-terms-privacy-platform
    [message]="'admin.global.byContinuingYouAgree' | translate"
  ></app-terms-privacy-platform>

  <!-- CAPTCHA Component -->
  <div class="row mb-3" *ngIf="showCaptchaChallenge">
    <div class="col-12">
      <app-recaptcha
        [siteKey]="captchaSiteKey"
        (captchaResolved)="onCaptchaResolved($event)"
        (captchaError)="onCaptchaError()"
        (captchaExpired)="onCaptchaExpired()"
      ></app-recaptcha>

      <div *ngIf="captchaError" class="alert alert-warning mt-2">
        <app-icon icon="fa fa-exclamation-circle mr-2"></app-icon>
        <span>{{ 'auth.captcha.required' | translate }}</span>
      </div>
    </div>
  </div>

  <div class="row my-3">
    <div [class.align-center]="!isNewRegisterUser" class="col-12">
      <app-button
        type="submit"
        variant="primary"
        class="w-100"
        classes="w-100 py-3"
        id="register-final-submit"
        [disabled]="!languageId || languageId <= 0"
      >
        {{ 'admin.register.acceptRegister' | translate }}
      </app-button>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <mat-label
        >{{ 'admin.register.haveAccount' | translate }}&nbsp;<app-button
          type="button"
          variant="none"
          classes="btn-link px-0 link-btn"
          (click)="goToLogin()"
        >
          {{ 'admin.global.login' | translate }}
        </app-button>
      </mat-label>
    </div>
  </div>
</form>
